<template>
  <ion-fab class="fab-translation-selector" :horizontal="horizontal" :vertical="vertical" slot="fixed"  v-show="availableLanguages && availableLanguages.length > 1">
    <ion-fab-button size="small">
      <ion-label v-text="selectedLanguage"></ion-label>      
    </ion-fab-button>
    <ion-fab-list :side="side">      
      <ion-fab-button
        color="light"
        v-for="language of availableLanguages"
        :key="language"
        :value="language"
        @click="selectLanguage(language)"
      >
        <ion-label v-text="language"></ion-label>      
      </ion-fab-button>
    </ion-fab-list>
  </ion-fab>
</template>

<script setup>
import translationService from "../composables/translationService";
import { IonFab, IonFabButton, IonFabList, IonLabel } from "@ionic/vue";
const availableLanguages = translationService.availableLanguages
</script>
<script >

//DE 🇩🇪 EN 🇬🇧 ES 🇪🇸
export default {  
  props: ["value", "horizontal", "vertical", "side"],
  components: { IonFab, IonFabButton, IonFabList, IonLabel },
  data() {
    return {}
  },
  watch: {},
  async unmounted() {},
  async mounted() {

  },

  computed: {
    selectedLanguage() {
      return translationService.selectedLanguage ? translationService.selectedLanguage.value : null;
    },
  }
  ,
  methods: {
    selectLanguage(language) {      
      translationService.selectLanguage(language)
    },
  },
  
}
</script>
<style scoped>
</style>>
